import { AlertTriangle } from 'lucide-react';

export default function DisabledProfilePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white rounded-[40px] border border-slate-200 p-12 shadow-sm text-center">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center">
            <AlertTriangle className="w-10 h-10 text-amber-600" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-slate-900 mb-4">
          Profile Disabled
        </h1>
        
        <p className="text-slate-600 mb-8 leading-relaxed">
          Your profile has been disabled. Please contact an administrator to enable your profile.
        </p>
        
        <p className="text-sm text-slate-500 mb-8">
          Once your profile is enabled, you'll be able to access all platform features and perform actions.
        </p>
      </div>
    </div>
  );
}

